import { Injectable } from '@angular/core';

@Injectable()
export class UserService {

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/services/user.service.ts